import { Info } from 'lucide-react';

import { cn } from '../../../lib/utils';
import { Popover, PopoverContent, PopoverTrigger } from '../Popover';

export type InfoHintProps = {
  term: string;
  children: string;
  className?: string;
};

export function InfoHint({ term, children, className }: InfoHintProps) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          aria-label={`What is ${term}?`}
          className={cn(
            'inline-flex size-4 shrink-0 items-center justify-center rounded-full text-text-tertiary transition-colors hover:text-text-secondary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
            className,
          )}
        >
          <Info className="size-3.5" aria-hidden="true" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-64 text-sm font-normal text-text-secondary">
        <p className="mb-1 font-medium text-text-primary">{term}</p>
        <p>{children}</p>
      </PopoverContent>
    </Popover>
  );
}
